export default "__VITE_ASSET__Bku8wlJY__"